
import { AboutUsView } from "../views/AboutusView.jsx"
import aboutUsData from "../data/aboutUsData";

function AboutUs() {
    return <AboutUsView aboutUsData={aboutUsData}  />;
  }
  
  export { AboutUs };
  